<template>
    <v-container fluid class="landing-fluid-wrapper">
        <header class="landing-bots-header">
            <v-container class="landing-bots-header-inner-wrapper">
                <div class="landing-bots-header-welcome">
                    <h1>
                        <span>Morning, &nbsp;</span><span>Ahmed</span>
                    </h1>
                    <p>
                        Welcome back to your account dashboard.
                        Here’s what's happening across your bots right now.
                    </p>
                </div>
                <div class="landing-bots-header-overlay">
                    <img src="../assets/img/header-overlay.png" alt="">
                </div>
            </v-container>

        </header>

        <v-container>
            <h2>My bots</h2>
            <small>Add or edit your bots from here</small>
            <v-layout>
                <v-flex
                        md3
                        v-for="bot in bots"
                        :key="bot.id"
                >
                    <div class="card-curvey text-xs-center" primary-title >
                        <div class="bot-info">
                            <span class="icon-wrapper">
                                <v-icon>mdi-robot</v-icon>

                            </span>
                            <h3 class=" mb-0">{{ bot.title}}</h3>
                            <v-chip
                                    class="ma-2"
                            >
                                Active
                            </v-chip>
                        </div>
                        <div class="bot-action" @click="selectBot(bot.id)">
                            Manage Bot
                        </div>
                    </div>

                </v-flex>
            </v-layout>
        </v-container>

    </v-container>
</template>

<script>
    import common from "../utils/common";


    export default {
        name: "Bots",
        data() {
            return {
                bots: [],
            }
        },
        mounted() {
            this.getUserBots()
            this.$store.dispatch('setBotId', '')
            localStorage.setItem('botId', '')
        },
        methods: {
            getUserBots() {
                this.$http.get('/bot/my')
                    .then(response => {
                        this.bots = response.data
                        this.handleAutoSelect()
                    })
                    .catch(error => {
                        if (error.response.status === 401) {
                            common.logOut()
                        }
                    });
            },
            selectBot(botId, redirect = 'build') {
                this.$store.dispatch('setBotId', botId)
                localStorage.setItem('botId', botId)
                this.$router.push(redirect)
                window.location.reload()
            },
            async handleAutoSelect() {
                if (this.bots.length && this.$store.state.user.roleId === 2) {
                    const botId = this.bots[0].id
                    this.selectBot(botId, '/insights')
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container.fluid {
        padding: 0;
    }

    .landing-fluid-wrapper{
        background-image: linear-gradient(235deg, #e0f3ff 53%, #bee4ff -5%, rgba(190, 228, 255, 0) -5%);
    }

    .landing-bots-header {
        height: 290px;
        background-image: url("../assets/img/header-bg.svg");
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        .landing-bots-header-inner-wrapper{
            height: 100%;
            padding: 0;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

    }
    .landing-bots-header-welcome{
        max-width: 440px;
        h1{
            color: #FFFFFF;
            font-size: 34px;
            font-weight: bold;
        }
        p{
            color: rgba(255, 255, 255, 0.7);
            font-size: 18px;
            font-weight: 300;
            line-height: 1.2;
        }
    }
    .landing-bots-header-overlay{
        height: 100%;
        padding-top: 2rem;
        img{
            max-height: 90%;
        }
    }
    h2{
        font-weight: bold;
        margin-top: 2rem;
        font-size: 31px;
    }
    smal{
        color: rgba(0, 0, 0, 0.8);
    }
    .card-curvey{
        height: 195px;
        width: 100%;
        position: relative;
        border-radius: 10px;
        .bot-info{
            span.icon-wrapper{
                display: flex;
                justify-content: center;
                align-items: center;
                width: 60px;
                height: 60px;
                border-radius: 50%;
                background-color: #0d1633;
                margin: 0 auto 0.5rem;

                i{
                    color: #FFFFFF;
                    font-size: 30px;
                }
            }
            h3{
                font-size: 1rem;
                color: #0d1633;
            }
            .v-chip{
                background-color: rgba(0, 168, 89, 0.15);
                color: #00a859;
                padding: 0 1rem;
            }
        }
    }
    .bot-action{
        cursor: pointer;
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
        text-align: center;
        background-color: #015efd;
        color: #FFFFFF;
        border-bottom-right-radius: 10px;
        border-bottom-left-radius: 10px;
        padding: 0.5rem;
        font-size: 14px;
    }

    .add-new-bot{
        background-color: #015efd;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #FFFFFF;
        font-size: 18px;
        font-weight: bold;
        margin-left: 2rem;
        margin-right: 2rem;
        cursor: pointer;
    }
</style>
